// externals
import React from 'react';
import { useSelector } from 'react-redux';

// libraries
import * as firstPencilSelectors from '@makemydeal/dr-dash-store/selectors/firstPencilSelectors';

// components
import { CreateDealSlideOutContent } from './CreateDealSlideOutContent';

// Gate only — mounted on every Dashboard render. Not route-gated: payments are held on the same flag,
// so hiding this elsewhere would hold pricing with no way to release it.
export const CreateDealModal: React.FC = () => {
    const show = useSelector(firstPencilSelectors.getShowCreateDealModal);

    if (!show) {
        return null;
    }

    return <CreateDealSlideOutContent />;
};

export default CreateDealModal;
